<div class="alert alert-success alert-dismissible fade show text-center mb-0" role="alert" *ngIf="displayInfoBox && aimMessage?.textActive">
  <strong>{{aimMessage.message}}</strong>
  <button [attr.data-test]="'btn-close'" type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close" (click)="displayInfoBox = false;"></button>
</div>
